import { Button, Dropdown, MenuProps, Row } from "antd";
import { usePrintInvestorsReport } from "../hooks/usePrintInvestorsReport";
import { DownOutlined } from "@ant-design/icons";
import { useCallback, useMemo } from "react";
import { usePermissions } from "../../../../../../../lib/hooks/usePermissions";

type HeaderProps = {
  customerId: string;
};

export const Header = ({ customerId }: HeaderProps) => {
  const { isLoading, print } = usePrintInvestorsReport(customerId);

  const { hasAccessByController } = usePermissions("ReportGeneration");

  const onPrint = useCallback(
    (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
      const id: string = e.currentTarget.id;
      print(id === "1" ? 1 : 0);
    },
    [print]
  );

  const printOptions: MenuProps["items"] = useMemo(
    () => [
      {
        key: 1,
        label: (
          <Row id="1" onClick={onPrint}>
            Buyer's Investor Report
          </Row>
        ),
      },
      {
        key: 2,
        label: (
          <Row id="2" onClick={onPrint}>
            Seller's Investor Report
          </Row>
        ),
      },
    ],
    [onPrint]
  );

  return (
    <Row className="card-header justify-space-between align-center w-100">
      <h5 className="h h5 card-header">Accounts</h5>
      {hasAccessByController("InvestorSummaryReport") && (
        <Dropdown
          menu={{ items: printOptions }}
          trigger={["click"]}
          disabled={isLoading}
        >
          <Button shape="round">
            Download <DownOutlined />
          </Button>
        </Dropdown>
      )}
    </Row>
  );
};
